import { render, staticRenderFns } from "./peachReport.vue?vue&type=template&id=b2e32b7e&"
import script from "./peachReport.vue?vue&type=script&lang=js&"
export * from "./peachReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports